import { WebPlugin } from '@capacitor/core';
export class GoogleSignInWeb extends WebPlugin {
    // @ts-ignore
    async handleSignInButton() {
        this.unimplemented('Not implemented on web.');
    }
    async restorePreviousSignIn() {
        this.unimplemented('Not implemented on web.');
    }
    async signOut() {
        this.unimplemented('Not implemented on web.');
    }
    // @ts-ignore
    checkScopes(options) {
        this.unimplemented('Not implemented on web.');
    }
    // @ts-ignore
    requestScopes(options) {
        this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map